<div class="auth-header{{ marginBottom ? ' -margin-bottom-' + marginBottom : ''}}">
    <div class="auth-header__inner">
        <shared-header class="auth-header__hd" *ngIf="preHeader" [center]="center" [brandAccent]="true"
            [type]="preHeaderType" [marginTop]="preHeaderMarginTop" [marginBottom]="preHeaderMarginBottom">
            <ng-container *ngTemplateOutlet="preHeader"></ng-container>
        </shared-header>
        <shared-header class="auth-header__bd" [center]="center" [type]="type" [marginTop]="marginTop"
            marginBottom="xs">
            <ng-content></ng-content>
        </shared-header>
        <shared-auth-description class="auth-header__desc">
            <ng-container *ngTemplateOutlet="description || null"></ng-container>
        </shared-auth-description>
    </div>
</div>